var _path, _path2, _circle, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorFileSharing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39 14v15.86l-8.27 21.14h-27.73a2.006 2.006 0 0 1 -2-2v-46a2.006 2.006 0 0 1 2-2h23a2.993 2.993 0 0 1 2.12.88l10 10a2.993 2.993 0 0 1 .88 2.12z",
    fill: "#e2e3ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.12 11.88a2.993 2.993 0 0 0 -2.12-.88h-5a2.006 2.006 0 0 1 -2-2v-5a2.993 2.993 0 0 0 -.88-2.12z",
    fill: "#c8cbdb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    fill: "#47d17f",
    r: 15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45 44v1.771a1.216 1.216 0 0 0 1.929.984l6.559-4.755a1.222 1.222 0 0 0 0-1.99l-6.575-4.77a1.2 1.2 0 0 0 -1.913 1v1.76c-6 0-9 5-9 10a23.794 23.794 0 0 0 .265 3.637.433.433 0 0 0 .849.026c.686-2.957 2.886-7.663 7.886-7.663z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a6aaba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33 18h-26a1 1 0 0 1 0-2h26a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 24h-26a1 1 0 0 1 0-2h26a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 30h-26a1 1 0 0 1 0-2h26a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 36h-20a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 42h-14a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorFileSharing);
export default __webpack_public_path__ + "static/media/vendor-file-sharing.60ebbbc77b6cab96de818c76d590c292.svg";
export { ForwardRef as ReactComponent };